import React, { useContext, useState } from "react";
// import { Collapse, Container, Navbar, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from "react-router-dom";

import AuthContext from "../../../../contexts/AuthContext";

import "./assets/css/side-menu.css";

const SideMenu: React.FC = () => {
  const { user, logged, Logout } = useContext(AuthContext);
  const [isOpen, setOpen] = useState(false);
  const [menuClass, setMenuClass] = useState("menu");

  const toggle = () => {
    let openTMP = !isOpen;
    setOpen(openTMP);
    setMenuClass(openTMP ? "menu menu--open" : "menu"); //Muda o nome da classe do menu baseado no estado do menu
  };

  const GetClass = (path: string): string => {
    return window.location.pathname === path ? "menu__item active" : "menu__item";
  }

  return (
    <React.Fragment>
      {logged && (
        <div className={menuClass}>
          <span className="menu__button menu__icon" onClick={toggle}>
            <svg id="btn--menu" xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18">
              <g fill="none" fillRule="evenodd" stroke="#A7B9DB" strokeLinecap="square" strokeWidth="2">
                <path d="M0 7.5L22 7.5M11 .5L22 .5M0 14.5L11 14.5" transform="translate(1 1.5)" />
              </g>
            </svg>
          </span>

          <nav className="menu__links">
            <ul>
              <React.Fragment>
                <li>
                  <Link to="/dashboard" className={GetClass('/dashboard')}>
                    {/* <a href="/dashboard" className={GetClass('/dashboard')}> */}
                    <span className="menu__icon">
                      <svg id="btn--dashboard" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
                        <g fill="none" fillRule="evenodd" transform="translate(-29 -20)">
                          <g stroke="#A7B9DB" strokeWidth="2" transform="translate(30 21)">
                            <path d="M3.414 17.586L8 13" />
                            <circle cx="2" cy="19" r="2" strokeLinecap="square" />
                            <path strokeLinecap="square" d="M21 19C21 8.507 12.493 0 2 0M2 4L2 6M12.607 8.393L11.192 9.808M17 19L15 19" />
                          </g>
                        </g>
                      </svg>
                    </span>
                    Dashboard
                  </Link>
                  {/* </a> */}
                </li>
              </React.Fragment>
              
              {user!.basicLayout ? null :
                <React.Fragment>
                  <li>
                    <Link to="/unities-groups" className={GetClass('/unities-groups')}>
                      {/* <a href="/unities-groups" className={GetClass('/unities-groups')}> */}
                      <span className="menu__icon">
                        <svg id="btn--groups" xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24">
                          <g fill="none" fillRule="evenodd" stroke="#A7B9DB" strokeLinecap="square" strokeWidth="2">
                            <path d="M0 9H18V23H0zM2 5L16 5M5 1L13 1" transform="translate(1)" />
                          </g>
                        </svg>
                      </span>
                      Unities & Groups
                    </Link>
                    {/* </a> */}
                  </li>
                  <li>
                    <Link to="/users" className={GetClass('/users')}>
                      {/* <a href="/users" className={GetClass('/users')}> */}
                      <span className="menu__icon">
                        <svg id="btn--users" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                          <g fill="none" fillRule="evenodd" transform="translate(-29 -20)">
                            <g stroke="#A7B9DB" strokeWidth="2">
                              <path d="M9 12c-2.824 0-5.329.638-6.975 1.193C.81 13.604 0 14.749 0 16.032V20h8" transform="translate(30 21)" />
                              <path strokeLinecap="square" d="M9 12h0c-2.761 0-5-3.239-5-6V5c0-2.761 2.239-5 5-5h0c2.761 0 5 2.239 5 5v1c0 2.761-2.239 6-5 6zM15 22L12 22 12 19 18 13 21 16z" transform="translate(30 21)" />
                            </g>
                          </g>
                        </svg>
                      </span>
                      Users
                      {/* </a> */}
                    </Link>
                  </li>
                </React.Fragment>
              }
              <li className="menu__links--keepMobile">
                <Link to="/actual-update" className={GetClass('/actual-update')}>
                  {/* <a href="/actual-update" className={GetClass('/actual-update')}> */}
                  <span className="menu__icon">
                    <svg id="btn--actual" xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20">
                      <g fill="none" fillRule="evenodd" strokeLinecap="square" transform="translate(-29 -22)">
                        <g>
                          <path stroke="#A7B9DB" strokeWidth="2" d="M6 18L6 5M11 18L11 10M16 18L16 5M21 18L21 10M1 18L1 0" transform="translate(29 23)" />
                        </g>
                      </g>
                    </svg>
                  </span>
                  Plan Update
                  {/* </a> */}
                </Link>
              </li>
              {user!.basicLayout ? null :
                <li className="menu__links--keepMobile">
                  <Link to="/plan-update" className={GetClass('/plan-update')}>
                    {/* <a href="/plan-update" className={GetClass('/plan-update')}> */}
                    <span className="menu__icon">
                      <svg
                        id="btn--plan"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          fillRule="evenodd"
                          stroke="#A7B9DB"
                          strokeLinecap="square"
                          strokeWidth="2"
                          transform="translate(1 1)"
                        >
                          <circle cx="11" cy="11" r="11" />
                          <circle cx="7" cy="7" r="2" />
                          <circle cx="15" cy="15" r="2" />
                          <path d="M7 15L15 7" />
                        </g>
                      </svg>
                    </span>
                    Plan Update
                  </Link>
                </li>
              }
              {user!.basicLayout ? null :
                <React.Fragment>
                  <li>
                    <Link to="/calendar-management" className={GetClass('/calendar-management')}>
                      {/* <a href="/calendar-management" className={GetClass('/calendar-management')}> */}
                      <span className="menu__icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23">
                          <g fill="none" fillRule="evenodd" transform="translate(1 1)">
                            <path stroke="#A7B9DB" strokeLinecap="square" strokeWidth="2" d="M4 11H6V12H4zM10 11H12V12H10zM4 16H6V17H4zM10 16H12V17H10zM16 11H18V12H16z" />
                            <path fill="#A7B9DB" fillRule="nonzero" d="M4 11H6V12H4zM10 11H12V12H10zM4 16H6V17H4zM10 16H12V17H10zM16 11H18V12H16z" />
                            <rect width="22" height="19" y="2" stroke="#A7B9DB" strokeLinecap="square" strokeWidth="2" rx="2" />
                            <path stroke="#A7B9DB" strokeLinecap="square" strokeWidth="2" d="M5 0L5 3M17 0L17 3M0 7L22 7" />
                          </g>
                        </svg>
                      </span>
                      Calendar
                      <br />
                      Management
                    </Link>
                  </li>
                  <li>
                    <Link to="/system" className={GetClass('/system')}>
                      <span className="menu__icon">
                        <svg id="btn--dashboard" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 23">
                          <g fill="none" fillRule="evenodd">
                            <g stroke="#A7B9DB" strokeWidth="2">
                              <g>
                                <g>
                                  <g>
                                    <path d="M11 22L11 9" transform="translate(-542 -752) translate(514 90) translate(0 642) translate(29 21)" />
                                    <path strokeLinecap="square" d="M7 13L11 9 15 13" transform="translate(-542 -752) translate(514 90) translate(0 642) translate(29 21)" />
                                    <path strokeLinecap="square" d="M15 17.777c4.48-1.02 7.472-5.252 6.94-9.816-.53-4.564-4.415-7.994-9.01-7.959C8.337.038 4.507 3.528 4.047 8.1c-2.51.51-4.228 2.831-3.983 5.38C.31 16.028 2.44 17.98 5 18h2" transform="translate(-542 -752) translate(514 90) translate(0 642) translate(29 21)" />
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </span>System
                    </Link>
                  </li>
                </React.Fragment>
              }
            </ul>
          </nav>
          <Link className="menu__logout menu__item" to="/login" onClick={(e) => { e.preventDefault(); Logout(true); }}>
            <span className="menu__icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18">
                <g fill="none" fillRule="evenodd" stroke="#FFF" strokeWidth="2">
                  <path d="M6.1 12c1.4 2.4 4 4 6.9 4 4.4 0 8-3.6 8-8s-3.6-8-8-8c-3 0-5.5 1.6-6.9 4M14 8L0 8" transform="matrix(-1 0 0 1 22 1)" />
                  <path strokeLinecap="square" d="M3 11L0 8 3 5" transform="matrix(-1 0 0 1 22 1)" />
                </g>
              </svg>
            </span>
            Logout
          </Link>
        </div>
      )}
    </React.Fragment>
  );
};

export default SideMenu;
